import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "416",
  "slug": "geoguessr-vs-earthguessr-comparison",
  "title": "GeoGuessr and EarthGuessr: Street Clues or Satellite Landscapes?",
  "excerpt": "The main difference is the view you read. Compare the clue types, map interaction, and access for the mode you want.",
  "date": "2026-06-12",
  "category": "Community",
  "image": "https://images.unsplash.com/photo-1614730321146-b6fa6a46bcb4?ixid=M3w5NjY4NzN8MHwxfHNlYXJjaHwxfHxlYXJ0aCUyMHNhdGVsbGl0ZSUyMHZpZXd8ZW58MXwwfHx8MTc4MTI1MjMwM3ww&ixlib=rb-4.1.0&w=800&q=80&fit=crop",
  "readTime": "2 min",
  "author": "EarthGuessr Team",
  "content": [
    {
      "type": "paragraph",
      "text": "GeoGuessr's familiar street-view format puts you among roads and buildings. EarthGuessr uses overhead satellite imagery. Before comparing scores or subscriptions, decide which view you want to reason from."
    },
    {
      "type": "heading",
      "text": "What you can inspect"
    },
    {
      "type": "paragraph",
      "text": "At street level, readable signs and roadside details may help identify a place. From above, look for the outline of a bay, the direction of ridges, or the arrangement of fields. The image scale determines which details are available."
    },
    {
      "type": "paragraph",
      "text": "A method based on license plates does not transfer directly to a satellite round. Broad geographic knowledge may help in both, but a clue needs to be visible in the image before it can be useful."
    },
    {
      "type": "heading",
      "text": "Access and group play"
    },
    {
      "type": "paragraph",
      "text": "GeoGuessr has a free-play route and paid Pro subscriptions. Check the chosen mode on its official site. EarthGuessr runs in a browser and requires sign-in for multiplayer; use the actual lobby settings when planning a group game."
    },
    {
      "type": "paragraph",
      "text": "This comparison is published by EarthGuessr. It does not claim independent testing of which product teaches geography better."
    },
    {
      "type": "heading",
      "text": "Try the same reasoning exercise"
    },
    {
      "type": "paragraph",
      "text": "After a round in each game, write the clue you relied on and one alternative location you considered. Compare whether the experience you preferred involved recognising signs, reading terrain, or simply exploring a place. That gives you a concrete reason to choose."
    }
  ],
  "sources": [
    {
      "title": "GeoGuessr: free-play entry point",
      "url": "https://www.geoguessr.com/free"
    },
    {
      "title": "GeoGuessr: 2026 subscription price changes",
      "url": "https://geoguessr.freshdesk.com/support/solutions/articles/206000067275-price-changes-2026"
    }
  ],
  "relatedSlugs": [
    "is-geoguessr-free",
    "how-to-get-better-at-geography-games"
  ]
};
